import React,{useEffect,useState }  from 'react'
import OperationsAndBenefitsMobile from './OperationsAndBenefitsMobile';


const OperationAndBenefits = ({title,subtitle,IconCard1,IconCard2,IconCard3,IconCard4,titleCard1,titleCard2,titleCard3,titleCard4,textCard1,textCard2,textCard3,textCard4, firstWordCard1,firstWordCard2,firstWordCard3,firstWordCard4}) => {
    const isComoFunciona = title === "Como funciona?";
    const [screenSize, setScreenSize] = useState('');
    useEffect(() => {
        const handleResize = () => {
        const screenWidth = window.innerWidth;

        if (screenWidth >= 1200) {
            setScreenSize('big');
        } else {
            setScreenSize('medium');
        }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
    <>
    {screenSize==="big" && 
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",padding:"50px 0 80px 0",backgroundColor:"rgba(255, 255, 255, 1)"}}>
    <div className='fz_title_components_owner'>
       { title==="Como funciona?" && <span>{title}</span> }
       { title==="Com a YOLO você tem:" && 
       <span> Com a <span style={{color:"#FF3097"}}> YOLO</span> você tem:</span> }
    </div>
    <div className='fz_sub_title_components_owner'>
        <span>{subtitle}</span>
    </div>

    <div style={{display:"flex",justifyContent:"center",backgroundColor:"rgba(255, 255, 255, 1)"}}>
        <div className='paddingDesktop' style={{display:"flex",width:"100%",maxWidth:"1340px",gap:"3%"}}>
            <div className={`cards_operation_owner ${isComoFunciona ? 'box_shadow_operation_owner' : 'back_white'}`} style={{width:"22%"}}>
                <img src={IconCard1} alt="" className={title === "Com a YOLO você tem:" ? 'img_48' : title === "Como funciona?" ? 'img_54' : ''} />
                <span className='texts_cards_who_we_are_yolo fw_700_important' style={{color:"#FF3097"}}>{titleCard1} </span>      
                { title ==="Como funciona?" 
                && <span className='font_size_operation_owner' style={{color:"#FF3097"}}>
                    {firstWordCard1}
                    <span style={{color:"#101828"}}>
                        {textCard1}
                    </span>
                    </span>

                }
                { title ==="Com a YOLO você tem:" && <span className='font_size_operation_owner' style={{color:"#667085",paddingTop:"5px"}}>{textCard1}</span>}
            </div>
            <div className={`cards_operation_owner ${isComoFunciona ? 'box_shadow_operation_owner' : 'back_white'}`} style={{width:"22%"}}>
                <img src={IconCard2} alt="" className={title === "Com a YOLO você tem:" ? 'img_48' : title === "Como funciona?" ? 'img_54' : ''} />
                <span className='texts_cards_who_we_are_yolo fw_700_important' style={{color:"#FF3097"}}>{titleCard2} </span>
                { title ==="Como funciona?" && <span className='font_size_operation_owner' style={{color:"#FF3097"}}> {firstWordCard2}  <span style={{color:"#101828"}}>{textCard2}</span> </span>}
                { title ==="Com a YOLO você tem:" && <span className='font_size_operation_owner' style={{color:"#667085",paddingTop:"5px"}}>{textCard2}</span>}
            </div>
            <div className={`cards_operation_owner ${isComoFunciona ? 'box_shadow_operation_owner' : 'back_white'}`} style={{width:"22%"}}>
                <img src={IconCard3} alt="" className={title === "Com a YOLO você tem:" ? 'img_48' : title === "Como funciona?" ? 'img_54' : ''} />
                <span className='texts_cards_who_we_are_yolo fw_700_important' style={{color:"#FF3097"}}>{titleCard3} </span>
                { title ==="Como funciona?" && <span className='font_size_operation_owner'  style={{color:"#FF3097"}}>
                  {firstWordCard3} <span style={{color:"#101828"}}>{textCard3}</span></span>}
                { title ==="Com a YOLO você tem:" && <span className='font_size_operation_owner' style={{color:"#667085",paddingTop:"5px"}}>{textCard3}</span>}
            </div>
            <div className={`cards_operation_owner ${isComoFunciona ? 'box_shadow_operation_owner' : 'back_white'}`} style={{width:"22%"}}>
                <img src={IconCard4} alt="" className={title === "Com a YOLO você tem:" ? 'img_48' : title === "Como funciona?" ? 'img_54' : ''} />
                <span className='texts_cards_who_we_are_yolo fw_700_important' style={{color:"#FF3097"}}>{titleCard4} </span>
                { title ==="Como funciona?" && <span className='font_size_operation_owner' style={{color:"#FF3097"}}>
                  {firstWordCard4} <span style={{color:"#101828"}}>{textCard4}</span></span>}
                { title ==="Com a YOLO você tem:" && <span className='font_size_operation_owner' style={{color:"#667085",paddingTop:"5px"}}>{textCard4}</span>}
            </div>
        </div>
</div>
    </div>}

    {screenSize==="medium" && title==="Como funciona?" && <OperationsAndBenefitsMobile title={title} IconCard1={IconCard1} IconCard2={IconCard2} IconCard3={IconCard3} IconCard4={IconCard4} firstWordCard1={firstWordCard1} firstWordCard2={firstWordCard2} firstWordCard3={firstWordCard3} firstWordCard4={firstWordCard4} titleCard1={titleCard1} titleCard2={titleCard2} titleCard3={titleCard3} titleCard4={titleCard4} textCard1={textCard1} textCard2={textCard2} textCard3={textCard3} textCard4={textCard4} heightText='120px' paddingComponent='40px 0 60px 0'/>}
    {screenSize==="medium" && title==="Com a YOLO você tem:" && <OperationsAndBenefitsMobile title={title} IconCard1={IconCard1} IconCard2={IconCard2} IconCard3={IconCard3} IconCard4={IconCard4} firstWordCard1={firstWordCard1} firstWordCard2={firstWordCard2} firstWordCard3={firstWordCard3} firstWordCard4={firstWordCard4} titleCard1={titleCard1} titleCard2={titleCard2} titleCard3={titleCard3} titleCard4={titleCard4} textCard1={textCard1} textCard2={textCard2} textCard3={textCard3} textCard4={textCard4} heightText='126px' paddingComponent='50px 0 80px 0'/>}
    </>
  )
}

export default OperationAndBenefits